import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutColumn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-column, grid, column"} maskId="square-filled-radius-0-stroke-1-IconLayoutColumn"><path d="M3 21V3H11.5V21L3 21Z" fill="currentColor"/><path d="M12.5 21L21 21V3H12.5V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutColumn;
